import Services from "../../services";

class PengakuanHutangApi {
  // API SERVER
  get(params) {
    return Services.get("approval_penyesuaian_piutang/list", { params });
  }

  getHistory(params) {
    return Services.get("approval_penyesuaian_piutang/history/list", {
      params,
    });
  }

  getSingle(params) {
    return Services.get("approval_penyesuaian_piutang/detail", { params });
  }

  approve(data) {
    return Services.post("approval_penyesuaian_piutang/approve", data);
  }
}

export default new PengakuanHutangApi();
